(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landing-results"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-results-carousel]').forEach((carousel) => {
    if (carousel.dataset.resultsInitialized === 'true') return;
    carousel.dataset.resultsInitialized = 'true';

    const rail = carousel.querySelector('[data-results-rail]');
    const previous = carousel.querySelector('[data-results-prev]');
    const next = carousel.querySelector('[data-results-next]');
    const cards = Array.from(carousel.querySelectorAll('.result-card'));
    const dots = Array.from(carousel.querySelectorAll('[data-results-dot]'));

    if (!rail || cards.length === 0) return;

    const cardOffset = (card) => card.offsetLeft - rail.offsetLeft;

    const visibleCardCount = () => {
      if (!cards[0]) return 1;
      const styles = window.getComputedStyle(rail);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      const cardSpan = cards[0].offsetWidth + gap;
      if (cardSpan <= 0) return 1;
      return Math.max(1, Math.min(cards.length, Math.round((rail.clientWidth + gap) / cardSpan)));
    };

    const positionCount = () => Math.max(1, cards.length - visibleCardCount() + 1);

    const nearestCardIndex = () => {
      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;
      const positions = positionCount();

      cards.slice(0, positions).forEach((card, index) => {
        const distance = Math.abs(cardOffset(card) - rail.scrollLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      return nearestIndex;
    };

    let currentIndex = 0;

    const updateControls = (activeIndex = currentIndex) => {
      const positions = positionCount();
      currentIndex = Math.max(0, Math.min(activeIndex, positions - 1));

      dots.forEach((dot, index) => {
        dot.hidden = index >= positions;
        const isActive = index === currentIndex;
        dot.classList.toggle('is-active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      if (previous) previous.disabled = positions <= 1;
      if (next) next.disabled = positions <= 1;
    };

    const scrollToCard = (index) => {
      const positions = positionCount();
      currentIndex = ((index % positions) + positions) % positions;
      const target = cards[currentIndex];
      if (!target) return;
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      rail.scrollTo({ left: cardOffset(target), behavior });
      updateControls(currentIndex);
    };

    if (previous) previous.addEventListener('click', () => scrollToCard(currentIndex - 1));
    if (next) next.addEventListener('click', () => scrollToCard(currentIndex + 1));

    dots.forEach((dot) => {
      dot.addEventListener('click', () => scrollToCard(Number(dot.dataset.resultsDot)));
    });

    let updateFrame;
    rail.addEventListener('scroll', () => {
      window.cancelAnimationFrame(updateFrame);
      updateFrame = window.requestAnimationFrame(() => {
        currentIndex = nearestCardIndex();
        updateControls(currentIndex);
      });
    }, { passive: true });

    window.addEventListener('resize', () => {
      currentIndex = Math.min(currentIndex, positionCount() - 1);
      rail.scrollTo({ left: cardOffset(cards[currentIndex]), behavior: 'auto' });
      updateControls(currentIndex);
    }, { passive: true });

    rail.scrollTo({ left: 0, behavior: 'auto' });
    updateControls(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-fresh-product]').forEach((root) => {
    const gallery = root.querySelector('[data-gallery]');
    const track = root.querySelector('[data-gallery-track]');
    const viewport = root.querySelector('[data-gallery-viewport]');
    const scroller = viewport || track;
    const optionInputs = Array.from(root.querySelectorAll('[data-pack-option]'));
    const slides = Array.from(root.querySelectorAll('[data-gallery-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    const prev = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');
    let current = 0;
    let swipe = null;

    if (slides.length <= 1) {
      gallery?.classList.add('has-single-slide');
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
    }

    // Highlights the current thumbnail. On the product's own cards (benefits, ingredients, how to use) the
    // pack saving badge is hidden: it describes a pack photo and would cover the card's heading.
    const markActive = () => {
      thumbs.forEach((thumb, thumbIndex) => {
        thumb.classList.toggle('is-active', thumbIndex === current);
        thumb.setAttribute('aria-current', thumbIndex === current ? 'true' : 'false');
      });
      gallery?.toggleAttribute('data-on-card', !slides[current]?.dataset.galleryProduct);
      // Keep the current thumbnail in view when the strip scrolls (a column on desktop, a row on phones).
      const thumb = thumbs[current];
      const strip = thumb?.parentElement;
      if (strip && (strip.scrollHeight > strip.clientHeight + 1 || strip.scrollWidth > strip.clientWidth + 1)) {
        const t = thumb.getBoundingClientRect();
        const b = strip.getBoundingClientRect();
        strip.scrollTo({
          top: strip.scrollTop + t.top - b.top - (strip.clientHeight - t.height) / 2,
          left: strip.scrollLeft + t.left - b.left - (strip.clientWidth - t.width) / 2,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
        });
      }
    };

    const showSlide = (index, behavior = 'smooth') => {
      if (!scroller || slides.length === 0) return;
      swipe = null;
      current = (index + slides.length) % slides.length;
      const trackOffset = track ? track.offsetLeft : 0;
      scroller.scrollTo({ left: slides[current].offsetLeft - trackOffset, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : behavior });
      markActive();
    };

    thumbs.forEach((thumb, thumbIndex) => {
      thumb.addEventListener('click', () => {
        showSlide(thumbIndex);
      });
    });

    if (prev) {
      prev.addEventListener('click', () => showSlide(current - 1));
    }

    if (next) {
      next.addEventListener('click', () => showSlide(current + 1));
    }

    if (gallery) {
      gallery.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        showSlide(current + (event.key === 'ArrowRight' ? 1 : -1));
      });
    }

    if (scroller) {
      scroller.addEventListener('pointerdown', () => {
        if (window.matchMedia('(min-width: 750px)').matches) {
          scroller.focus({ preventScroll: true });
        }
      });
      let galleryScrollFrame = 0;
      scroller.addEventListener('scroll', () => {
        if (galleryScrollFrame) return;
        galleryScrollFrame = window.requestAnimationFrame(() => {
          galleryScrollFrame = 0;
          const trackOffset = track ? track.offsetLeft : 0;
          const nextIndex = slides.reduce((closest, slide, index) => {
            const distance = Math.abs((slide.offsetLeft - trackOffset) - scroller.scrollLeft);
            const closestDistance = Math.abs((slides[closest].offsetLeft - trackOffset) - scroller.scrollLeft);
            return distance < closestDistance ? index : closest;
          }, current);
          current = nextIndex;
          markActive();
        });
      }, { passive: true });
    }

    if (scroller && window.ResizeObserver) {
      let galleryWidth = scroller.clientWidth;
      new ResizeObserver(() => {
        if (scroller.clientWidth === galleryWidth) return;
        galleryWidth = scroller.clientWidth;
        showSlide(current, 'instant');
      }).observe(scroller);
    }

    // Touch: a swipe moves one photo at most, however fast the flick. The CSS snap stops most
    // flicks; this holds the scroll within one photo of where the finger went down for the rest,
    // until the next touch or a move made with the arrows, thumbnails or mouse.
    if (scroller && slides.length > 1) {
      const leftOf = (index) => slides[Math.min(slides.length - 1, Math.max(0, index))].offsetLeft - (track ? track.offsetLeft : 0);
      scroller.addEventListener('touchstart', () => { swipe = { min: leftOf(current - 1), max: leftOf(current + 1) }; }, { passive: true });
      scroller.addEventListener('scroll', () => {
        if (!swipe) return;
        if (scroller.scrollLeft < swipe.min - 1) scroller.scrollLeft = swipe.min;
        else if (scroller.scrollLeft > swipe.max + 1) scroller.scrollLeft = swipe.max;
      }, { passive: true });
    }

    // Never rest between two photos: if a scroll ends off a photo's edge, close the gap.
    scroller?.addEventListener('scrollend', () => {
      if (!slides.length || gallery?.classList.contains('is-dragging')) return;
      const target = slides[current].offsetLeft - (track?.offsetLeft || 0);
      if (Math.abs(scroller.scrollLeft - target) > 1) scroller.scrollTo({ left: target, behavior: 'smooth' });
    });

    // Mouse: click and drag the photo sideways to move one photo at a time (touch swipes scroll natively).
    if (scroller && gallery && slides.length > 1) {
      let drag = null;
      scroller.addEventListener('dragstart', (event) => event.preventDefault());
      scroller.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, a, summary, video, details')) return;
        swipe = null;
        drag = { x: event.clientX, left: scroller.scrollLeft, index: current, moved: false };
      });
      window.addEventListener('pointermove', (event) => {
        if (!drag) return;
        const distance = event.clientX - drag.x;
        if (!drag.moved && Math.abs(distance) < 6) return;
        drag.moved = true;
        gallery.classList.add('is-dragging');
        scroller.scrollLeft = drag.left - distance;
      });
      const endDrag = (event) => {
        if (!drag) return;
        const { moved, index } = drag;
        const distance = event.clientX - drag.x;
        drag = null;
        if (!moved) return;
        gallery.classList.remove('is-dragging');
        const step = Math.abs(distance) > 40 ? (distance < 0 ? 1 : -1) : 0;
        showSlide(Math.min(slides.length - 1, Math.max(0, index + step)));
      };
      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);
    }

    const variantInput = root.querySelector('[data-selected-variant-input]');
    const addButton = root.querySelector('[data-add-button]');
    const productForm = root.querySelector('.fresh-product-form');
    /* "Best Value" goes on the option with the biggest saving that can be bought, when there is one. */
    const savingOptions = Array.from(root.querySelectorAll('[data-pack-option]')).filter(option => !option.disabled && Number(option.dataset.savingPercent) > 0);
    if (savingOptions.length > 1) {
      const bestOption = savingOptions.reduce((best, option) => Number(option.dataset.savingPercent) > Number(best.dataset.savingPercent) ? option : best);
      const bestCard = bestOption.closest('.fresh-pack-option')?.querySelector('.fresh-pack-card');
      if (bestCard && !bestCard.querySelector('.fresh-pack-card__badge')) {
        const badge = document.createElement('span');
        badge.className = 'fresh-pack-card__badge';
        badge.textContent = root.dataset.bestValueText || 'Best Value';
        bestCard.classList.add('fresh-pack-card--best');
        bestCard.prepend(badge);
      }
    }
    const contentsDisclosures = Array.from(root.querySelectorAll('.fresh-pack-option__contents, .fresh-gallery__contents'));
    const galleryContents = root.querySelector('.fresh-gallery__contents');
    if (galleryContents) {
      const stage = galleryContents.closest('.fresh-gallery__stage');
      const panel = galleryContents.querySelector('.fresh-gallery__contents-panel');
      const updateContentsSpace = () => {
        // Keep the frame fixed; reserve the open panel's actual height inside the media.
        stage.style.setProperty('--gallery-contents-space', `${galleryContents.open ? panel.offsetHeight + 8 : 0}px`);
      };
      galleryContents.addEventListener('toggle', updateContentsSpace);
      if (window.ResizeObserver) new ResizeObserver(updateContentsSpace).observe(panel);
      updateContentsSpace();
    }

    contentsDisclosures.forEach(details => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        contentsDisclosures.forEach(other => {
          if (other !== details) other.open = false;
        });
        /* A pack tile's list floats over the tile, so the page must not move for it. Only the gallery's list is scrolled into view. */
        if (details.classList.contains('fresh-pack-option__contents')) return;
        window.requestAnimationFrame(() => {
          if (!details.open) return;
          const panel = details.querySelector('.fresh-gallery__contents-panel');
          if (!panel) return;
          const headerBottom = document.querySelector('.site-header')?.getBoundingClientRect().bottom || 0;
          const visibleTop = Math.max(0, headerBottom) + 12;
          const panelTop = panel.getBoundingClientRect().top;
          if (panelTop < visibleTop) {
            window.scrollBy({ top: panelTop - visibleTop, behavior: 'instant' });
          }
        });
      });
      details.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !details.open) return;
        event.preventDefault();
        event.stopPropagation();
        details.open = false;
        details.querySelector('summary')?.focus({ preventScroll: true });
      });
    });
    if (contentsDisclosures.length) {
      document.addEventListener('click', event => {
        contentsDisclosures.forEach(details => {
          if (details.open && !details.contains(event.target)) details.open = false;
        });
      });
    }
    const stickyBar = root.querySelector('[data-sticky-bar]');
    const stickyButton = root.querySelector('[data-sticky-button]');
    const selectedPrice = root.querySelector('[data-selected-price]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const productPanel = root.querySelector('.fresh-product__panel');
    if (productPanel && window.ResizeObserver) {
      new ResizeObserver(() => {
        productPanel.style.setProperty('--product-panel-height', `${productPanel.offsetHeight}px`);
      }).observe(productPanel);
    }
    if (slides.length < 2) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      root.querySelector('.fresh-gallery__thumbs')?.setAttribute('hidden', '');
    }
    const stickyComparePrice = root.querySelector('[data-sticky-compare-price]');
    const stickyTitle = root.querySelector('.fresh-product-sticky [data-sticky-title]');
    const stickyMedia = root.querySelector('.fresh-product-sticky__image');
    const savingBadge = root.querySelector('[data-product-saving-badge]');
    const soldOutText = root.dataset.soldOutText || 'Sold out';
    const addText = root.dataset.addText || 'Add To Cart';
    const buyNowText = root.dataset.buyNowText || 'Shop Now';
    const buttonIcon = '<svg class="fresh-button-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M2.5 3.5h3l2.3 12h11l2-8.5H6.2"/><circle cx="9" cy="20" r="1.25"/><circle cx="18" cy="20" r="1.25"/></svg>';

    /* Marks the chosen tile's wrapper, so its styles do not depend on :has(). */
    const markSelectedPack = () => optionInputs.forEach((option) => option.closest('.fresh-pack-option-wrap')?.classList.toggle('is-selected', option.checked));
    markSelectedPack();
    optionInputs.forEach((input) => {
      input.addEventListener('change', () => {
        markSelectedPack();
        if (!input.checked) return;
        const isAvailable = input.dataset.available === 'true';
        if (variantInput) variantInput.value = input.dataset.variantId || input.value;
        if (selectedPrice) selectedPrice.textContent = input.dataset.price || '';
        if (stickyPrice) stickyPrice.textContent = input.dataset.price || '';
        if (stickyComparePrice) {
          stickyComparePrice.textContent = input.dataset.comparePrice || '';
          stickyComparePrice.hidden = !input.dataset.comparePrice;
        }
        if (stickyTitle) stickyTitle.textContent = input.dataset.stickyTitle || '';
        if (savingBadge) {
          const savingPercent = Math.max(0, Number(input.dataset.savingPercent || 0));
          savingBadge.textContent = savingPercent > 0 ? `${savingPercent}% OFF` : '';
          savingBadge.hidden = savingPercent <= 0;
        }
        if (stickyMedia) {
          /* The sticky bar shows the studio photo, not the tile's cut-out. */
          const optionMedia = input.closest('.fresh-pack-option')?.querySelector('template[data-sticky-media]');
          if (optionMedia) stickyMedia.replaceChildren(optionMedia.content.cloneNode(true));
        }
        if (addButton) {
          const compareMarkup = input.dataset.comparePrice ? `<s data-selected-compare-price>${input.dataset.comparePrice}</s>` : '';
          addButton.disabled = !isAvailable;
          addButton.classList.toggle('fresh-add-button--sold-out', !isAvailable);
          addButton.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
          addButton.innerHTML = isAvailable ? `${buttonIcon}${addText} <span class="fresh-add-button__prices"><span data-selected-price>${input.dataset.price || ''}</span>${compareMarkup}</span>` : soldOutText;
        }
        if (stickyButton) {
          stickyButton.disabled = !isAvailable;
          stickyButton.textContent = isAvailable ? buyNowText : soldOutText;
        }
        if (input.dataset.packType) {
          const targetIndex = slides.findIndex((slide) => slide.dataset.galleryProduct === input.dataset.productHandle);
          if (targetIndex >= 0) showSlide(targetIndex, 'instant');
        }
      });
    });

    const requestedPack = new URLSearchParams(window.location.search).get('pack');
    if (requestedPack === 'two') {
      const bundlePack = optionInputs.find((input) => input.dataset.packType === 'bundle');
      if (bundlePack && !bundlePack.disabled && !bundlePack.checked) {
        bundlePack.checked = true;
        bundlePack.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    const checkedPack = optionInputs.find((input) => input.checked && input.dataset.packType);
    if (checkedPack) {
      const targetIndex = slides.findIndex((slide) => slide.dataset.galleryProduct === checkedPack.dataset.productHandle);
      if (targetIndex >= 0) showSlide(targetIndex, 'instant');
    }

    /* Image viewer: tap a gallery photo to open every photo large, with zoom. */
    (() => {
      const gallery = root.querySelector('[data-gallery]');
      if (!gallery || !document.createElement('dialog').showModal) return;
      const photos = () => Array.from(gallery.querySelectorAll('[data-gallery-slide] > img')).filter((img) => img.getClientRects().length || img.currentSrc || img.src);
      const large = (img) => {
        try {
          const url = new URL(img.currentSrc || img.src, window.location.href);
          url.searchParams.set('width', '2400');
          return url.toString();
        } catch (error) { return img.currentSrc || img.src; }
      };
      const viewer = document.createElement('dialog');
      viewer.className = 'fresh-viewer';
      viewer.setAttribute('aria-label', 'Product photos');
      viewer.innerHTML = '<div class="fresh-viewer__stage" data-viewer-stage><img class="fresh-viewer__image" data-viewer-image alt="" draggable="false"></div>'
        + '<button class="fresh-viewer__button fresh-viewer__close" type="button" data-viewer-close aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>'
        + '<button class="fresh-gallery__arrow fresh-viewer__nav fresh-viewer__nav--prev" type="button" data-viewer-prev aria-label="Previous photo"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path class="carousel-arrow__chevron" d="M15.5 5 8.5 12l7 7"/><path class="carousel-arrow__full" d="M19 12H5m6-6-6 6 6 6"/></svg></button>'
        + '<button class="fresh-gallery__arrow fresh-viewer__nav fresh-viewer__nav--next" type="button" data-viewer-next aria-label="Next photo"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path class="carousel-arrow__chevron" d="m8.5 5 7 7-7 7"/><path class="carousel-arrow__full" d="M5 12h14m-6-6 6 6-6 6"/></svg></button>'
        + '<div class="fresh-viewer__thumbs" data-viewer-thumbs></div>';
      document.body.appendChild(viewer);
      const stage = viewer.querySelector('[data-viewer-stage]');
      const image = viewer.querySelector('[data-viewer-image]');
      const thumbs = viewer.querySelector('[data-viewer-thumbs]');
      let list = [];
      let index = 0;
      let scale = 1;
      let x = 0;
      let y = 0;
      const apply = () => {
        const maxX = Math.max(0, (image.clientWidth * scale - stage.clientWidth) / 2);
        const maxY = Math.max(0, (image.clientHeight * scale - stage.clientHeight) / 2);
        x = Math.min(maxX, Math.max(-maxX, x));
        y = Math.min(maxY, Math.max(-maxY, y));
        image.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
        stage.classList.toggle('is-zoomed', scale > 1.01);
      };
      const zoomTo = (next) => {
        scale = Math.min(3, Math.max(1, next));
        if (scale === 1) { x = 0; y = 0; }
        apply();
      };
      /* One click or tap zooms in on that spot; the next one zooms back out. */
      const toggleZoom = (clientX, clientY) => {
        image.style.transition = '';
        if (scale > 1.01) { zoomTo(1); return; }
        const box = stage.getBoundingClientRect();
        scale = 2;
        x = (clientX - (box.left + box.width / 2)) * (1 - scale);
        y = (clientY - (box.top + box.height / 2)) * (1 - scale);
        apply();
      };
      const show = (next) => {
        index = (next + list.length) % list.length;
        image.src = large(list[index]);
        image.alt = list[index].alt || '';
        scale = 1; x = 0; y = 0;
        apply();
        thumbs.querySelectorAll('button').forEach((button, i) => button.classList.toggle('is-active', i === index));
        const multiple = list.length > 1;
        viewer.querySelectorAll('.fresh-viewer__nav').forEach((button) => { button.hidden = !multiple; });
        thumbs.hidden = !multiple;
      };
      const open = (img) => {
        list = photos();
        if (!list.length) return;
        thumbs.innerHTML = '';
        list.forEach((photo, i) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', `Photo ${i + 1} of ${list.length}`);
          const small = document.createElement('img');
          small.src = photo.currentSrc || photo.src;
          small.alt = '';
          button.appendChild(small);
          button.addEventListener('click', () => show(i));
          thumbs.appendChild(button);
        });
        viewer.showModal();
        show(Math.max(0, list.indexOf(img)));
      };
      let downAt = null;
      gallery.addEventListener('pointerdown', (event) => { downAt = { x: event.clientX, y: event.clientY }; });
      gallery.addEventListener('click', (event) => {
        const img = event.target.closest('[data-gallery-slide] > img');
        if (!img) return;
        /* A swipe between slides should not open the viewer. */
        if (downAt && Math.hypot(event.clientX - downAt.x, event.clientY - downAt.y) > 8) return;
        open(img);
      });
      viewer.querySelector('[data-viewer-close]').addEventListener('click', () => viewer.close());
      viewer.querySelector('[data-viewer-prev]').addEventListener('click', () => show(index - 1));
      viewer.querySelector('[data-viewer-next]').addEventListener('click', () => show(index + 1));
      viewer.addEventListener('keydown', (event) => {
        const zoomed = scale > 1.01;
        const pan = { ArrowLeft: [100, 0], ArrowRight: [-100, 0], ArrowUp: [0, 100], ArrowDown: [0, -100] }[event.key];
        if (event.key === '+' || event.key === '=') zoomTo(2);
        else if (event.key === '-') zoomTo(1);
        else if (pan && zoomed) { event.preventDefault(); x += pan[0]; y += pan[1]; apply(); }
        else if (event.key === 'ArrowLeft') show(index - 1);
        else if (event.key === 'ArrowRight') show(index + 1);
      });
      const points = new Map();
      let pinch = 0;
      let moved = false;
      let start = null;
      let pinched = false;
      stage.addEventListener('pointerdown', (event) => {
        stage.setPointerCapture(event.pointerId);
        points.set(event.pointerId, { x: event.clientX, y: event.clientY });
        moved = false;
        if (points.size === 1) { start = { x: event.clientX, y: event.clientY }; pinched = false; }
        else pinched = true;
        if (points.size === 2) {
          const [a, b] = Array.from(points.values());
          pinch = Math.hypot(a.x - b.x, a.y - b.y) / scale;
        }
      });
      stage.addEventListener('pointermove', (event) => {
        const last = points.get(event.pointerId);
        if (!last) return;
        const now = { x: event.clientX, y: event.clientY };
        points.set(event.pointerId, now);
        if (points.size === 2 && pinch) {
          const [a, b] = Array.from(points.values());
          zoomTo(Math.hypot(a.x - b.x, a.y - b.y) / pinch);
        } else if (points.size === 1 && scale > 1.01 && event.pointerType !== 'mouse') {
          x += now.x - last.x;
          y += now.y - last.y;
          moved = true;
          image.style.transition = 'none';
          apply();
        }
      });
      const release = (event) => {
        points.delete(event.pointerId);
        if (points.size < 2) pinch = 0;
      };
      /* Zoomed in with a mouse: the photo follows the pointer, so moving towards an edge shows that edge. */
      const follow = (clientX, clientY) => {
        const box = stage.getBoundingClientRect();
        x = (clientX - (box.left + box.width / 2)) * (1 - scale);
        y = (clientY - (box.top + box.height / 2)) * (1 - scale);
        apply();
      };
      stage.addEventListener('mousemove', (event) => {
        if (scale <= 1.01) return;
        image.style.transition = 'transform 90ms linear';
        follow(event.clientX, event.clientY);
      });
      /* The image element fills the stage; the photo itself is letterboxed inside it. */
      const onPhoto = (clientX, clientY) => {
        const box = image.getBoundingClientRect();
        const ratio = image.naturalWidth && image.naturalHeight ? image.naturalWidth / image.naturalHeight : 1;
        const width = Math.min(box.width, box.height * ratio);
        const height = width / ratio;
        const left = box.left + (box.width - width) / 2;
        const top = box.top + (box.height - height) / 2;
        return clientX >= left && clientX <= left + width && clientY >= top && clientY <= top + height;
      };
      stage.addEventListener('pointerup', (event) => {
        const from = start;
        const wasPinch = pinched;
        release(event);
        image.style.transition = '';
        if (points.size || !from || wasPinch) return;
        start = null;
        const dx = event.clientX - from.x;
        const dy = event.clientY - from.y;
        if (Math.hypot(dx, dy) < 8) {
          /* A tap on the photo toggles zoom; a tap on the dark area around it closes the viewer. */
          if (scale > 1.01) zoomTo(1);
          else if (onPhoto(event.clientX, event.clientY)) toggleZoom(event.clientX, event.clientY);
          else viewer.close();
        } else if (scale <= 1.01 && list.length > 1 && Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          /* Not zoomed: a sideways swipe moves to the next or previous photo. */
          show(index + (dx < 0 ? 1 : -1));
        }
      });
      stage.addEventListener('pointercancel', release);
    })();

    root.querySelectorAll('[data-directions]').forEach((directions) => {
      const tabs = Array.from(directions.querySelectorAll('[data-directions-tab]'));
      const panels = Array.from(directions.querySelectorAll('[data-directions-panel]'));
      const select = (index, focus) => {
        tabs.forEach((tab, i) => {
          tab.classList.toggle('is-active', i === index);
          tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
          tab.tabIndex = i === index ? 0 : -1;
        });
        panels.forEach((panel, i) => { panel.hidden = i !== index; });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') { event.preventDefault(); select((index + 1) % tabs.length, true); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); select((index - 1 + tabs.length) % tabs.length, true); }
        });
      });
    });

    root.querySelectorAll('[data-buy-box-jump]').forEach((button) => {
      button.addEventListener('click', () => {
        const target = productForm || root.querySelector('.fresh-product__panel');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    if (stickyButton && productForm) {
      stickyButton.addEventListener('click', () => {
        productForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    const setStickyVisibility = (shouldShow) => {
      if (!stickyBar || !stickyButton) return;
      stickyBar.classList.toggle('is-visible', shouldShow && !stickyButton.disabled);
    };

    if (stickyBar && stickyButton && addButton) {
      let stickyFrame = 0;
      const updateStickyVisibility = () => {
        stickyFrame = 0;
        setStickyVisibility(addButton.getBoundingClientRect().bottom <= 0);
      };
      const scheduleStickyVisibility = () => {
        if (!stickyFrame) stickyFrame = window.requestAnimationFrame(updateStickyVisibility);
      };
      if ('IntersectionObserver' in window) {
        const stickyObserver = new IntersectionObserver(scheduleStickyVisibility, { threshold: 0 });
        stickyObserver.observe(addButton);
      }
      // Anchor jumps can skip the button without changing its intersection state.
      window.addEventListener('scroll', scheduleStickyVisibility, { passive: true });
      window.addEventListener('resize', scheduleStickyVisibility, { passive: true });
      updateStickyVisibility();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
